var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mine" }, [
    _c("div", { staticStyle: { margin: "0 20px" } }, [
      _c(
        "div",
        { staticClass: "mine_headers" },
        [
          _c("tabs", {
            attrs: { "tabs-list": _vm.tabsList },
            on: { tabs: _vm.handleTabChange },
          }),
          _c(
            "div",
            { staticClass: "date_box" },
            [
              _c("search", {
                attrs: { model: _vm.model, "search-list": _vm.searchList },
                on: { changeDate: _vm.changeDate },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "table_box" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "el-table-infinite-scroll",
                rawName: "v-el-table-infinite-scroll",
                value: _vm.loadList,
                expression: "loadList",
              },
            ],
            ref: "table",
            staticClass: "scpc-task-table",
            style: {
              width: "100%",
            },
            attrs: {
              data: _vm.tableData,
              border: "",
              "highlight-current-row": "",
              height: "100%",
              "header-cell-style": {
                background: "#F1F1F1 ",
                fontSize: "14px",
                color: "#999999",
              },
              "cell-style": {
                fontSize: "14px",
              },
              "row-style": { height: "38" },
              "infinite-scroll-distance": 50,
            },
          },
          _vm._l(_vm.tableColumns, function (column, index) {
            return _c("el-table-column", {
              key: column.prop || index,
              attrs: {
                prop: column.prop,
                label: column.label,
                "min-width": column.width,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { staticStyle: { "white-space": "pre-wrap" } },
                          [_vm._v(_vm._s(scope.row[column.prop]))]
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }